import { Params } from '@angular/router';
import { Facet, Facets } from '@app/shared/models/facets.model';

export function transformFacetsToUrlParams(facets: Facets): Params {
  return Object.keys(facets)
    .map((key) => ({
      key,
      value: facets[key].map(({ value }) => value).join(','),
    }))
    .reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {});
}

export function hydrateSelectedFacets(facets: Facets, selected: Facets): Facets {
  return Object.keys(selected)
    .map((key) => {
      if (key === 'search' || key === 'dates') {
        return { [key]: selected[key] };
      }
      const matchingFacets: Facet[] =
        facets[key]?.filter((facet: Facet) => {
          return selected[key].some((selectedFacet) => selectedFacet.value === facet.value);
        }) ?? [];
      return { [key]: matchingFacets };
    })
    .reduce((acc, facet) => ({ ...acc, ...facet }), {});
}

export function extractFacets(queryParams: Params): Facets {
  const facets = {};
  Object.keys(queryParams).forEach((key) => {
    const value = queryParams[key];
    facets[key] = value.split(',').map((facetValue) => ({
      value: facetValue,
      display: facetValue,
    }));
  });
  return facets;
}
